import { axiosClientAuth } from '../utils/retry-logic';

export function getListDeviceAPI(params) {
  return axiosClientAuth.get('api/v1/assets-list', {params});
}

export function getDeviceInformation(params){
  return axiosClientAuth.get(`api/v1/assets/${params.id}`)
}

export function deleteDeviceAPI(params) {
  return axiosClientAuth.delete(`api/v1/assets/${params.id}`);
}

export function addDeviceAPI(params) {
  return axiosClientAuth.post(`api/v1/assets`,params);
}

export function editDeviceAPI(params) {
  return axiosClientAuth.put(`api/v1/assets/${params.id}`,params);
}

export function getListSitesAPI(params) {
  return axiosClientAuth.get('api/v1/multiple-sites', {params})
}
